import script from "./XN550Barcode.vue?vue&type=script&lang=js"
export * from "./XN550Barcode.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/views/cases/XN550Barcode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24ee93a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24ee93a8', __exports__)) {
    console.log('reload')
    api.reload('24ee93a8', __exports__)
  }
  
}


export default __exports__